import React from 'react';
import { Picture } from '@beef/smart-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var AsadeImage = function AsadeImage(_ref) {
  var imageDesktop = _ref.imageDesktop,
    imageMobile = _ref.imageMobile;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('img'),
    "data-t-id": "components-AsadeImage"
  }, /*#__PURE__*/React.createElement(Picture, {
    source: [{
      media: 'max-width: 650px',
      srcset: imageMobile
    }],
    src: imageDesktop
  }));
};